import { action } from "mobx";
import { initialState } from "./state";

const createSimpleSetter = (store, key) =>
  action(value => {
    store[key] = value;
  });

const createArraySetter = (store, key) =>
  action(items => {
    if (Array.isArray(items)) {
      store[key] = [...items];
    } else if (items === null || items === undefined) {
      store[key] = [];
    } else {
      console.warn(`ProfilesAddonStore: ${key} received invalid data:`, items);
      if (!Array.isArray(store[key])) store[key] = [];
    }
  });

const createObjectSetter = (store, key) =>
  action(data => {
    if (data && typeof data === "object") {
      store[key] = { ...data };
    } else {
      console.warn(`ProfilesAddonStore: ${key} received invalid data:`, data);
      store[key] = {};
    }
  });

export const createMutations = store => ({
  // Modal
  setModalOpen: createSimpleSetter(store, "modalOpen"),

  // Step 1
  setSelectedCandidates: createArraySetter(store, "selectedCandidates"),
  setSelectedFields: createObjectSetter(store, "selectedFields"),
  setSearchBy: createSimpleSetter(store, "searchBy"),
  setDataFilters: createObjectSetter(store, "dataFilters"),
  setSearchInput: createSimpleSetter(store, "searchInput"),
  setSearchResults: createArraySetter(store, "searchResults"),
  setIsSearching: createSimpleSetter(store, "isSearching"),
  setDropdownOpen: createSimpleSetter(store, "dropdownOpen"),
  setDragIndex: createSimpleSetter(store, "dragIndex"),
  setDragOverIdx: createSimpleSetter(store, "dragOverIdx"),
  setAccentColor: createSimpleSetter(store, "accentColor"),

  // Step 2
  setStep: createSimpleSetter(store, "step"),
  setColumnsPerRow: createSimpleSetter(store, "columnsPerRow"),
  setRowGroups: createArraySetter(store, "rowGroups"),
  setDrag2: createSimpleSetter(store, "drag2"),
  setDrag2OverRow: createSimpleSetter(store, "drag2OverRow"),

  // Reset — deep-resets nested objects so MobX detects the change
  setDefaultState: action(() => {
    store.modalOpen = false;
    store.selectedCandidates = [];
    store.selectedFields = { ...initialState.selectedFields };
    store.searchBy = initialState.searchBy;
    store.dataFilters = { ...initialState.dataFilters };
    store.searchInput = "";
    store.searchResults = [];
    store.isSearching = false;
    store.dropdownOpen = false;
    store.dragIndex = null;
    store.dragOverIdx = null;
    store.step = 1;
    store.columnsPerRow = 2;
    store.rowGroups = [];
    store.drag2 = null;
    store.drag2OverRow = null;
    store.accentColor = initialState.accentColor;
  }),
});
